import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger-2",
  "use": "icon-hamburger-2-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-hamburger-2\"><defs><style>#icon-hamburger-2 .cls-1{opacity:0.5;}#icon-hamburger-2 .cls-2{fill:#fff;}</style></defs><g id=\"icon-hamburger-2_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-hamburger-2_圖層_1-2\" data-name=\"圖層 1\"><g class=\"cls-1\"><rect class=\"cls-2\" width=\"17\" height=\"3\" /><rect class=\"cls-2\" y=\"7\" width=\"17\" height=\"3\" /><rect class=\"cls-2\" y=\"14\" width=\"17\" height=\"3\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol